import { useFormContext, useFormState, useWatch } from "react-hook-form";

import { RenderElement } from "@up/form";

export function CurrentSchoolState() {
  const { control, register } = useFormContext();
  const { errors } = useFormState();
  const formValues = useWatch();

  return (
    <RenderElement
      control={control}
      element={{
        type: "stateselect",
        name: "current-school-address-state",
        label: "Current School State",
        validate: {
          presence: true,
        },
        dependent: {
          dependentName: "current-school-address-country",
          condition: "equal",
          conditionValue: "United States",
        },
      }}
      errors={errors}
      formValues={formValues}
      register={register}
      wrapperProps={{ className: "mb-8" }}
    />
  );
}
